<script lang="ts">
  import { ValidationResult } from "../../util/validations"
  import { AlertCircle } from "svelte-feathers"

  export let when: boolean
  export let error: ValidationResult
</script>

{#if when && error !== undefined}
  <div class="text-red-700 font-semibold flex items-center">
    <span class="shrink-0"><AlertCircle size="16" strokeWidth={2.5} /></span>
    <div class="flex-1 inline-block pl-3px" role="status">{error}</div>
  </div>
{/if}
